import React from 'react';

// 定义内容块类型
export interface TextBlock {
  type: 'text';
  content: string;
  bold?: boolean;
  underline?: boolean;
}

export interface SubtitleBlock {
  type: 'subtitle';
  content: string;
}

export interface ParagraphBlock {
  type: 'paragraph';
  content: string;
  bold?: boolean;
  underline?: boolean;
}

export interface ListBlock {
  type: 'list';
  items: Array<{
    title?: string;
    content: string;
  }>;
}

export interface ContactCardItem {
  label: string;
  href?: string;
  value: string;
}

export interface ContactCardBlock {
  type: 'contact-card';
  items: ContactCardItem[];
}

export type ContentBlock = TextBlock | SubtitleBlock | ParagraphBlock | ListBlock | ContactCardBlock;

export interface PrivacySection {
  title: string;
  blocks: ContentBlock[];
}

interface PrivacySectionContentProps {
  blocks: ContentBlock[];
}

// 渲染单个内容块
const renderBlock = (block: ContentBlock, index: number): React.ReactNode => {
  switch (block.type) {
    case 'subtitle':
      return (
        <h6 key={index} className="margin-bottom margin-xxsmall">
          {block.content}
        </h6>
      );

    case 'paragraph':
      const paragraphContent = block.bold && block.underline ? (
        <b><u>{block.content}</u></b>
      ) : block.bold ? (
        <b>{block.content}</b>
      ) : (
        block.content
      );
      
      return (
        <p key={index} className="text-size-regular margin-bottom margin-xxsmall">
          {paragraphContent}
        </p>
      );

    case 'list':
      return (
        <ul key={index}>
          {block.items.map((item, itemIndex) => (
            <li key={itemIndex}>
              {item.title && <b>{item.title}</b>}
              {item.title ? ' ' : ''}{item.content}
            </li>
          ))}
        </ul>
      );

    case 'contact-card':
      return (
        <div key={index} className="privacy-contact-card">
          {block.items.map((item, i) => (
            <div key={i} className="privacy-contact-item">
              <span className="privacy-contact-label">{item.label}</span>
              {item.href ? (
                <a href={item.href} className="privacy-contact-link">{item.value}</a>
              ) : (
                <span>{item.value}</span>
              )}
            </div>
          ))}
        </div>
      );

    default:
      return null;
  }
};

// 隐私政策章节内容渲染组件
export const PrivacySectionContent: React.FC<PrivacySectionContentProps> = ({ blocks }) => {
  return (
    <div className="margin-bottom margin-large">
      {blocks.map((block, index) => renderBlock(block, index))}
    </div>
  );
};

export default PrivacySectionContent;

